<template>
  <!-- <img style="width: 100%" src="../../assets/img.png" alt="" /> -->
  <div class="dash">
    <img class="img" src="../../assets/dash/dash-icon1.png" alt="" />
    <div class="con">
      <!-- 今日入境 -->
      <div class="head" v-if="DataNum.T11_0001 && DataNum.T11_0001.data">
        <!-- <div
          style="
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 30%;
          "
        >
          <div class="box" v-if="DataNum.T11_0001 && DataNum.T11_0001.data">
            <div
              :style="{
                color:
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .day_tb >= 0
                    ? '#00C132'
                    : '#FF3A3D',
              }"
            >
              {{
                DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                  .day_tb
              }}%
            </div>
            <img
              v-if="
                DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                  .day_tb < 0
              "
              class="arrow"
              src="../../assets/dash/dash-icon4.png"
              alt=""
            />
            <img
              v-if="
                DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                  .day_tb >= 0
              "
              class="arrow"
              src="../../assets/dash/dash-icon3.png"
              alt=""
            />
          </div>
          <div class="text" style="text-align: left">同比</div>
        </div> -->
        <div
          style="
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
          "
          v-if="DataNum.T11_0001 && DataNum.T11_0001.data"
        >
          <div class="nums">
            {{ DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code].jin
            }}<span
              style="
                color: #999999;
                font-size: 1rem;
                margin-left: 0.2rem;
                font-weight: 400;
              "
              >{{ DataNum.T11_0001.module.d1[0].unit }}</span
            >
          </div>
          <div class="text">{{ DataNum.T11_0001.module.d1[0].name }}</div>
        </div>
        <div
          style="
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
          "
          v-if="DataNum.T11_0001 && DataNum.T11_0001.data"
        >
          <div class="nums">
            {{ DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code].chu
            }}<span
              style="
                color: #999999;
                font-size: 1rem;
                margin-left: 0.2rem;
                font-weight: 400;
              "
              >{{ DataNum.T11_0001.module.d1[0].unit }}</span
            >
          </div>
          <div class="text">{{ DataNum.T11_0001.module.d1[1].name }}</div>
        </div>
        <div
          style="
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
          "
          v-if="DataNum.T11_0001 && DataNum.T11_0001.data"
        >
          <div class="nums">
            {{ DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code].liu
            }}<span
              style="
                color: #999999;
                font-size: 1rem;
                margin-left: 0.2rem;
                font-weight: 400;
              "
              >{{ DataNum.T11_0001.module.d1[0].unit }}</span
            >
          </div>
          <div class="text">{{ DataNum.T11_0001.module.d1[2].name }}</div>
        </div>
        <!-- <div
          style="
            height: 100%;
            width: 30%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          "
          v-if="DataNum.T11_0001 && DataNum.T11_0001.data"
        >
          <div class="box" style="justify-content: flex-end">
            <div
              :style="{
                color:
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .day_hb >= 0
                    ? '#00C132'
                    : '#FF3A3D',
              }"
            >
              {{
                DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                  .day_hb
              }}%
            </div>
            <img
              v-if="
                DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                  .day_hb >= 0
              "
              class="arrow"
              src="../../assets/dash/dash-icon3.png"
              alt=""
            />
            <img
              v-if="
                DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                  .day_hb < 0
              "
              class="arrow"
              src="../../assets/dash/dash-icon4.png"
              alt=""
            />
          </div>
          <div class="text" style="text-align: right">环比</div>
        </div> -->
      </div>
      <!-- 本月/本年入境 -->
      <!-- <div
        style="
          display: flex;
          width: 100%;
          justify-content: space-between;
          margin-top: 0.8rem;
        "
        v-if="DataNum.T11_0001 && DataNum.T11_0001.data"
      >
        <div
          style="
            width: 49%;
            background: linear-gradient(180deg, #f0fff1 0%, #ffffff 100%);
            padding: 0.8rem 0.8rem;
            box-sizing: border-box;
            border-radius: 0.6rem;
            border: 2px solid #fff;
          "
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
            "
          >
            <div class="text">本月入境</div>
            <div style="font-size: 1.3rem; font-weight: bold">
            <unms :value="DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code].month"/>
              <span style="font-size: 0.7rem; color: #333333"> {{
                DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code].month>100000?'万'+DataNum.T11_0001.module.d1[0].unit:DataNum.T11_0001.module.d1[0].unit
              }}</span>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin: 0.5rem 0;
            "
          >
            <div class="text">同比</div>
            <div class="box">
              <div
                style="font-size: 0.9rem"
                :style="{
                  color:
                    DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                      .month_tb >= 0
                      ? '#00C132'
                      : '#FF3A3D',
                }"
              >
                {{
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .month_tb
                }}%
              </div>
              <img
                v-if="
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .month_tb < 0
                "
                class="arrow"
                src="../../assets/dash/dash-icon4.png"
                alt=""
              />
              <img
                v-if="
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .month_tb >= 0
                "
                class="arrow"
                src="../../assets/dash/dash-icon3.png"
                alt=""
              />
            </div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div class="text">环比</div>
            <div class="box">
              <div
                style="font-size: 0.9rem"
                :style="{
                  color:
                    DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                      .month_hb >= 0
                      ? '#00C132'
                      : '#FF3A3D',
                }"
              >
                {{
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .month_hb
                }}%
              </div>
              <img
                v-if="
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .month_hb < 0
                "
                class="arrow"
                src="../../assets/dash/dash-icon4.png"
                alt=""
              />
              <img
                v-if="
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .month_hb >= 0
                "
                class="arrow"
                src="../../assets/dash/dash-icon3.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div
          style="
            width: 49%;
            background: linear-gradient(180deg, #fef1ff 0%, #ffffff 100%);
            padding: 0.8rem 0.8rem;
            box-sizing: border-box;
            border-radius: 0.6rem;
            border: 2px solid #fff;
          "
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
            "
          >
            <div class="text">本年入境</div>
            <div style="font-size: 1.3rem; font-weight: bold">
              <unms :value="DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code].year"/>
              <span style="font-size: 0.7rem; color: #333333">{{DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code].year>100000?'万'+DataNum.T11_0001.module.d1[0].unit:DataNum.T11_0001.module.d1[0].unit}}</span>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin: 0.5rem 0;
            "
          >
            <div class="text">同比</div>
            <div class="box">
              <div
                style="font-size: 0.9rem"
                :style="{
                  color:
                    DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                      .year_tb >= 0
                      ? '#00C132'
                      : '#FF3A3D',
                }"
              >
                {{
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .year_tb
                }}%
              </div>
              <img
                v-if="
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .year_tb < 0
                "
                class="arrow"
                src="../../assets/dash/dash-icon4.png"
                alt=""
              />
              <img
                v-if="
                  DataNum.T11_0001.data[DataNum.T11_0001.module.d1[0].code]
                    .year_tb >= 0
                "
                class="arrow"
                src="../../assets/dash/dash-icon3.png"
                alt=""
              />
            </div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div class="text">环比</div>
            <div class="box">
              <div class="title1" style="font-size: 0.9rem">0%</div>
              <img
                class="arrow"
                src="../../assets/dash/dash-icon3.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div> -->
      <!-- 本年车流峰值 -->
      <div class="peak" v-if="DataNum.T11_0003 && DataNum.T11_0003.data">
        <div class="peak_title">
          <img class="peak_img" src="../../assets/dash/dash-icon8.png" alt="" />
          <div class="peak_text">本年车流峰值分析</div>
        </div>
        <div class="peak_m">
          <div class="m_one">
            <div class="one_con">
              <div class="one_nums">
                <unms
                  :value="
                    DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                      .month_up
                  "
                />
              </div>
              <div class="one_l">
                {{
                  DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                    .month_up > 100000
                    ? "万" + DataNum.T11_0003.module.d1[0].unit
                    : DataNum.T11_0003.module.d1[0].unit
                }}
              </div>
            </div>
            <div class="one_con">
              <div class="one_text">月最高过车辆</div>
              <img
                class="one_img"
                src="../../assets/dash/dash-icon2.png"
                alt=""
              />
            </div>
            <div class="one_con">
              <div class="one_text">日期</div>
              <div class="one_text">
                {{
                  DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                    .month_up_date
                }}
              </div>
            </div>
          </div>
          <div class="m_one">
            <div class="one_con">
              <div class="one_nums" style="color: #ff8110">
                <unms
                  :value="
                    DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                      .month_down
                  "
                />
              </div>
              <div class="one_l">
                {{
                  DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                    .month_down > 100000
                    ? "万" + DataNum.T11_0003.module.d1[0].unit
                    : DataNum.T11_0003.module.d1[0].unit
                }}
              </div>
            </div>
            <div class="one_con">
              <div class="one_text">月最低过车辆</div>
              <img
                class="one_img"
                src="../../assets/dash/dash-icon.png"
                alt=""
              />
            </div>
            <div class="one_con">
              <div class="one_text">日期</div>
              <div class="one_text">
                {{
                  DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                    .month_down_date
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="peak_d">
          <div class="m_one">
            <div class="one_con">
              <div class="one_nums">
                {{
                  DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                    .day_up
                }}
              </div>
              <div class="one_l">辆</div>
            </div>
            <div class="one_con">
              <div class="one_text">日最高过车辆</div>
              <img
                class="one_img"
                src="../../assets/dash/dash-icon2.png"
                alt=""
              />
            </div>
            <div class="one_con">
              <div class="one_text">日期</div>
              <div class="one_text">
                {{
                  DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                    .day_up_date
                }}
              </div>
            </div>
          </div>
          <div class="m_one">
            <div class="one_con">
              <div class="one_nums" style="color: #ff8110">
                {{
                  DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                    .day_down
                }}
              </div>
              <div class="one_l">辆</div>
            </div>
            <div class="one_con">
              <div class="one_text">日最低过车辆</div>
              <img
                class="one_img"
                src="../../assets/dash/dash-icon.png"
                alt=""
              />
            </div>
            <div class="one_con">
              <div class="one_text">日期</div>
              <div class="one_text">
                {{
                  DataNum.T11_0003.data[DataNum.T11_0003.module.d1[0].code][0]
                    .day_down_date
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 本年入境车辆 -->
      <div class="entry" v-if="DataNum.T11_0008 && DataNum.T11_0008.data">
        <div class="peak_title">
          <img class="peak_img" src="../../assets/dash/dash-icon8.png" alt="" />
          <div class="peak_text">本年入境车辆车型分析</div>
        </div>
        <div class="entry_one">
          <div class="one_head">
            <div class="entry_num" style="text-align: left">
              {{ DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code].yj
              }}<span class="num_t">%</span>
            </div>
            <div class="entry_num">
              {{ DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code].gjyj
              }}<span class="num_t">{{
                DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code]
                  .gjyj_unit
              }}</span>
            </div>
            <div class="entry_num" style="text-align: right">
              {{ DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code].gj
              }}<span class="num_t">{{
                DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code]
                  .gj_unit
              }}</span>
            </div>
          </div>
          <div class="entry_x">
            <div
              class="x_num"
              :style="{
                width:
                  DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code].yj +
                  '%',
              }"
            ></div>
          </div>
          <div class="one_bot">
            <div class="bot_num" style="text-align: left">预警车辆占比</div>
            <div class="bot_num">过境预警车辆</div>
            <div class="bot_num" style="text-align: right">过境车辆</div>
          </div>
        </div>
        <div class="entry_two">
          <div class="one_head">
            <div class="entry_num" style="text-align: left">
              {{ DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code].big
              }}<span class="num_t">%</span>
            </div>
            <div class="entry_num">
              {{
                DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code].small
              }}<span class="num_t">%</span>
            </div>
            <div class="entry_num" style="text-align: right">
              {{
                DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code].other
              }}<span class="num_t">%</span>
            </div>
          </div>
          <div class="entry_x">
            <div
              class="x_num"
              :style="{
                width: `${
                  DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code].big
                }%`,
                'border-radius': '0.8rem 0 0 0.8rem',
                'background-color': '#ffcf22',
              }"
            ></div>
            <div
              class="x_num"
              :style="{
                width: `${
                  DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code]
                    .small
                }%`,
                'border-radius': '0',
                'background-color': '#399dff',
              }"
            ></div>
            <div
              class="x_num"
              :style="{
                width: `${
                  DataNum.T11_0008.data[DataNum.T11_0008.module.d2[0].code]
                    .other
                }%`,
                'border-radius': '0 0.8rem 0.8rem 0',
                'background-color': '#deefff',
              }"
            ></div>
          </div>
          <div class="one_bot">
            <div class="bot_num" style="text-align: left">大型车</div>
            <div class="bot_num">小型车</div>
            <div class="bot_num" style="text-align: right">其他车型</div>
          </div>
        </div>
      </div>
      <!-- 本年过境 -->
      <div class="transit" v-if="DataNum.T11_0012 && DataNum.T11_0012.data">
        <div class="peak_title">
          <img class="peak_img" src="../../assets/dash/dash-icon8.png" alt="" />
          <div class="peak_text">本年过境车辆停留时长占比</div>
        </div>
        <div class="transit_con">
          <div
            class="transit_list"
            v-for="(item, index) in DataNum.T11_0012.data[
              DataNum.T11_0012.module.d2[0].code
            ]"
            :key="index"
          >
            <div class="transit_time">{{ item.name }}</div>
            <div class="transit_x">
              <div
                class="x_num"
                :style="{
                  width: item.value + '%',
                }"
              ></div>
            </div>
            <div class="transit_num">{{ item.value }}%</div>
          </div>
        </div>
      </div>
      <!-- 各卡口过车 -->
      <div class="mount" v-if="DataNum.T11_0010 && DataNum.T11_0010.data">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="peak_title">
            <img
              class="peak_img"
              src="../../assets/dash/dash-icon8.png"
              alt=""
            />
            <div class="peak_text">各卡口过车情况统计</div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
            "
          >
            <div class="mount_d">{{ titleDay }}</div>
            <div class="arrow-down" @click="ondown"></div>
            <div class="mount_xz" v-if="mount">
              <div style="padding: 0.4rem" @click="ontime(1)">今日</div>
              <div style="padding: 0.2rem" @click="ontime(2)">近30日</div>
              <div style="padding: 0.4rem" @click="ontime(3)">近1年</div>
            </div>
          </div>
        </div>
        <div class="mount_con">
          <div ref="chart" style="width: 100%; height: 20rem"></div>
        </div>
      </div>
      <!-- 本年车辆 -->
      <div class="car1" v-if="DataNum.T11_0005 && DataNum.T11_0005.data">
        <div class="peak_title">
          <img class="peak_img" src="../../assets/dash/dash-icon8.png" alt="" />
          <div class="peak_text">本年车辆来源省份</div>
        </div>
        <div class="car_con">
          <div class="car_one">
            <div class="car_o_t" style="width: 20%">排名</div>
            <div class="car_o_t" style="width: 40%">城市</div>
            <div class="car_o_t" style="width: 40%">车流·辆</div>
            <div class="car_o_t" style="width: 20%">占比</div>
          </div>
          <div
            class="car_list"
            v-for="(item, index) in showAll1
              ? DataNum.T11_0005.data[DataNum.T11_0005.module.d2[0].code]
              : DataNum.T11_0005.data[DataNum.T11_0005.module.d2[0].code].slice(
                  0,
                  5
                )"
            :key="index"
            :style="{
              backgroundColor: index % 2 === 1 ? '#f3f9ff' : 'transparent',
            }"
          >
            <div class="car_o_t1" style="width: 20%">
              <img
                v-if="index == 0"
                class="car_img"
                src="../../assets/dash/dash-icon7.png"
                alt=""
              />
              <img
                v-if="index == 1"
                class="car_img"
                src="../../assets/dash/dash-icon5.png"
                alt=""
              />
              <img
                v-if="index == 2"
                class="car_img"
                src="../../assets/dash/dash-icon6.png"
                alt=""
              />
              <span v-if="index > 2">{{ index + 1 }}</span>
            </div>
            <div class="car_o_t1" style="width: 40%">{{ item.name }}</div>
            <div class="car_o_t1" style="width: 40%">{{ item.value }}</div>
            <div class="car_o_t1" style="width: 20%">{{ item.zb }}%</div>
          </div>
          <div
            class="car_bot"
            v-if="
              DataNum.T11_0005.data[DataNum.T11_0005.module.d2[0].code].length >
              5
            "
            @click="toggleShowAll(1)"
          >
            {{ showAll1 ? "收起" : "展开更多" }}
          </div>
        </div>
      </div>
      <div class="car1" v-if="DataNum.T11_0006 && DataNum.T11_0006.data">
        <div class="peak_title">
          <img class="peak_img" src="../../assets/dash/dash-icon8.png" alt="" />
          <div class="peak_text">本年车辆来源城市</div>
        </div>
        <div class="car_con">
          <div class="car_one">
            <div class="car_o_t" style="width: 20%">排名</div>
            <div class="car_o_t" style="width: 40%">城市</div>
            <div class="car_o_t" style="width: 40%">车流·辆</div>
            <div class="car_o_t" style="width: 20%">占比</div>
          </div>
          <div
            class="car_list"
            v-for="(item, index) in showAll2
              ? DataNum.T11_0006.data[DataNum.T11_0006.module.d2[0].code]
              : DataNum.T11_0006.data[DataNum.T11_0006.module.d2[0].code].slice(
                  0,
                  5
                )"
            :key="index"
            :style="{
              backgroundColor: index % 2 === 1 ? '#f3f9ff' : 'transparent',
            }"
          >
            <div class="car_o_t1" style="width: 20%">
              <img
                v-if="index == 0"
                class="car_img"
                src="../../assets/dash/dash-icon7.png"
                alt=""
              />
              <img
                v-if="index == 1"
                class="car_img"
                src="../../assets/dash/dash-icon5.png"
                alt=""
              />
              <img
                v-if="index == 2"
                class="car_img"
                src="../../assets/dash/dash-icon6.png"
                alt=""
              />
              <span v-if="index > 2">{{ index + 1 }}</span>
            </div>
            <div class="car_o_t1" style="width: 40%">{{ item.name }}</div>
            <div class="car_o_t1" style="width: 40%">{{ item.value }}</div>
            <div class="car_o_t1" style="width: 20%">{{ item.zb }}%</div>
          </div>
          <div
            class="car_bot"
            v-if="
              DataNum.T11_0006.data[DataNum.T11_0006.module.d2[0].code].length >
              5
            "
            @click="toggleShowAll(2)"
          >
            {{ showAll2 ? "收起" : "展开更多" }}
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bot_title">版权所有：陕西关山草原旅游发展有限责任公司</div>
  </div>
</template>
<script>
import request from "@/api/index";
import * as echarts from "echarts";
import unms from "@/components/index.vue";
export default {
  components: {
    unms,
  },
  data() {
    return {
      code: "", //授权返回的code
      openId: "",
      mount: false,
      showAll2: false,
      showAll1: false,
      DataNum: {}, //数据
      titleDay: "今日",
    };
  },
  async mounted() {
    // const params = new URLSearchParams(window.location.search);
    // const code = params.get("code"); // 成功获取code
    // this.code = code ? code : "";
    // const opens = localStorage.getItem("openid");
    // if (opens) {
    //   this.openId = opens;
    //   this.getTok(opens);
    // } else {
    //   if (this.code) {
    //     const res = await request.wxcode(this.code);
    //     localStorage.setItem("openid", res.data.openId);
    //     this.openId = res.data.openId;
    //     this.getTok(res.data.openId);
    //   } else {
    //     this.$router.push({
    //       path: "/login",
    //       query: {
    //         url: window.location.href,
    //       },
    //     });
    //   }
    // }
    const token = sessionStorage.getItem("token");
    console.log(token);
    if (token) {
      this.getlist(token);
    } else {
      this.$router.push({
        path: "/Newlogin",
      });
    }
  },
  methods: {
    // //获取tonken
    // async getTok(openid) {
    //   const res = await request.getToken(openid);
    //   console.log(JSON.parse(res.data.data), "poiiu");
    //   const list = JSON.parse(res.data.data);
    //   this.getlist(list.access_token);
    // },
    //展开
    toggleShowAll(index) {
      if (index == 1) {
        this.showAll1 = !this.showAll1;
      }
      if (index == 2) {
        this.showAll2 = !this.showAll2;
      }
    },
    //选择展示数据
    ondown() {
      this.mount = true;
    },
    ontime(index) {
      if (index == 1) {
        //今日数据
        this.mount = false;
        this.titleDay = "今日";
        this.initChart(this.DataNum.T11_0010);
      }
      if (index == 2) {
        //30日数据
        this.mount = false;
        this.titleDay = "近30日";
        this.initChart(this.DataNum.T11_0011);
      }
      if (index == 3) {
        //一年数据
        this.mount = false;
        this.titleDay = "近一年";
        this.initChart(this.DataNum.T11_0007);
      }
    },
    //图表数据
    async getlist(token) {
      const data = [
        { modelCode: "T11_0001", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0003", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0004", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0005", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0006", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0010", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0011", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0007", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0008", areaCode: "GSJQ_0001" },
        { modelCode: "T11_0012", areaCode: "GSJQ_0001" },
      ];
      const res = await request.DataRole(data, token);
      if (res.data.status == 1) {
        this.DataNum = res.data.data;
        try {
          await this.$nextTick(); // 再等待 DOM 更新
          this.initChart(res.data.data.T11_0010);
        } catch (err) {
          console.error("初始化失败:", err);
        }
      } else {
        this.$router.push({
          path: "/Newlogin",
        });
      }
    },

    initChart(item) {
      this.chart = echarts.init(this.$refs.chart);
      const option = {
        tooltip: {
          trigger: "axis",
          formatter:
            '{b}<br/>{a0}: <span style="color: #399DFF">{c0}</span>辆<br/>{a1}: <span style="color: #05C578">{c1}</span>辆',
        },
        legend: {
          textStyle: { color: "#333" },
          left: "left",
          top: "top",
          padding: [15, 0, 0, 0],
        },
        grid: {
          left: "4%",
          right: "5%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: item.data[item.module.d2[1].code].map((item) => {
            return item.time;
          }),
          axisLine: {
            show: true,
            lineStyle: { color: "#666" },
          },
          axisTick: { show: false },
          axisLabel: { color: "#666" },
        },
        yAxis: {
          type: "value",
          axisTick: { show: false },
        },
        series: [
          {
            name: item.data[item.module.d2[0].code][0].name,
            type: "line",
            data: item.data[item.module.d2[1].code].map((item) => {
              return item.yjgsrk;
            }),
            lineStyle: { width: 1, color: "#399DFF" },
            itemStyle: { color: "#399DFF" },
            symbol: "circle",
            symbolSize: 4,
            stack: "total",
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(57, 157, 255, 0.3)",
                  },
                  {
                    offset: 1,
                    color: "rgba(57, 157, 255, 0)",
                  },
                ],
              },
            },
          },
          {
            name: item.data[item.module.d2[0].code][1].name,
            type: "line",
            data: item.data[item.module.d2[1].code].map((item) => {
              return item.bsrk;
            }),
            lineStyle: { width: 1, color: "#05C578" },
            itemStyle: { color: "#05C578" },
            symbol: "circle",
            symbolSize: 4,
            stack: "total",
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(57, 157, 255, 0.3)",
                  },
                  {
                    offset: 1,
                    color: "rgba(57, 157, 255, 0)",
                  },
                ],
              },
            },
          },
        ],
        graphic: [
          {
            type: "text",
            right: "5%",
            top: "5%",
            style: {
              text: "单位：" + item.module.d2[1].unit,
              textAlign: "right",
              fill: "#666",
              fontSize: 12,
            },
          },
        ],
      };

      this.chart.setOption(option);

      // 自动轮播逻辑
      this.startTooltipCarousel();

      // 响应式调整
      window.addEventListener("resize", this.handleResize);
    },

    startTooltipCarousel() {
      if (this.carouselInterval) clearInterval(this.carouselInterval);

      let currentIndex = 0;
      const dataLen = 7; // 对应xAxis.data的长度

      this.carouselInterval = setInterval(() => {
        this.chart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentIndex,
        });

        currentIndex = (currentIndex + 1) % dataLen;
      }, 3000); // 3秒切换一次

      // 鼠标交互控制
      this.chart.on("mouseover", () => {
        clearInterval(this.carouselInterval);
      });

      this.chart.on("mouseout", () => {
        this.startTooltipCarousel();
      });
    },

    handleResize() {
      this.chart && this.chart.resize();
    },

    beforeDestroy() {
      // 清除定时器和事件监听
      if (this.carouselInterval) clearInterval(this.carouselInterval);
      window.removeEventListener("resize", this.handleResize);
      this.chart && this.chart.dispose();
    },
  },
};
</script>
<style  scoped>
@import "Dashboard.css";
</style>